import React, {useCallback, memo} from 'react';
import ReactPlayer from 'react-player';
import PropTypes from 'prop-types';
import {CloseIcon} from '../../../SvgComponents/SvgComponents';
import Modal from '../../ModalNew';
import './ModalVideoPlayer.less';

function ModalVideoPlayer({
  onClose, videoSrc, text,
}) {
  const closeModal = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <Modal className="modal-center modal-video-player" isOpen={!!videoSrc} onHide={closeModal}>
      <div className="modal-inner">
        <div className="modal-container">
          <button
            type="button"
            className="close-btn"
            onClick={closeModal}
          >
            <CloseIcon />
          </button>
          {text && (<div className="modal-video-player_title">{text}</div>)}
          <div className="modal-video-player_content">
            <div className="modal-video-player_video-wrap">
              <ReactPlayer
                config={{
                  file: {attributes: {preload: 'metadata'}},
                  youtube: {playerVars: {showinfo: 0, autohide: 1}},
                }}
                url={videoSrc}
                width="100%"
                height="100%"
                playing
                controls
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

ModalVideoPlayer.defaultProps = {
  text: '',
  videoSrc: '',
};

ModalVideoPlayer.propTypes = {
  text: PropTypes.string,
  videoSrc: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

export default memo(ModalVideoPlayer);
